export default "__VITE_ASSET__Cdya9SAF__"